import { BREAKPOINT } from '@ab-core/breakpoints';
import { useIsMobile } from '@ab-core/functions';

export const showComparison = () => {
    const isMobile = useIsMobile(BREAKPOINT.LG);

    return !isMobile;
};
